<template>
  <div>
    <slot name="header"></slot>
    <div class="template-two-hero-banner">
      <slot name="hero"></slot>
    </div>
    <div class="template-2-breadcrumb">
      <slot name="breadcrumb"></slot>
    </div>

    <div class="course-tile-list-v2-wrapper h-screen">
      <div
        class="template-two-container flex md:flex-row flex-col md:space-x-5"
      >
        <slot
          v-if="courseSettings.sidebar_position == 2"
          name="right-sidebar"
        ></slot>
        <slot name="course"></slot>
        <slot
          v-if="courseSettings.sidebar_position == 1"
          name="right-sidebar"
        ></slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'CategoryMarkup',
  data() {
    return {};
  },
  props: {
    courseSettings: {},
  },
};
</script>
<style lang="scss">
.template-two-container {
  max-width: 1130px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
  .md\:w-8\/12 {
    width: 66.666667%;
  }
  .md\:w-4\/12 {
    width: 36.333333%;
  }
}
</style>